<i18n>
{
  "en": {
    "parentProduct": "Product",
    "childProduct": "Recommendation",
    "edit": "Edit",
    "delete": "Delete",
    "undefinedProduct": "Loading information..."
  },
  "es": {
    "parentProduct": "Producto",
    "childProduct": "Recomendación",
    "edit": "Editar",
    "delete": "Eliminar",
    "undefinedProduct": "Cargando información..."
  }
}
</i18n>

<template>
  <v-card class="d-flex flex-column px-3 pl-5">
    <div class="d-flex flex-row justify-space-between align-center">
      <v-card-title class="pt-3 pb-0 pl-0">{{ ruleName }}</v-card-title>
      <div v-if="!$vuetify.breakpoint.smAndDown">
        <v-list-item-action class="mx-0" v-for="button in buttonConfigList" :key="button.title"
                            @click="onClick(button)">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-on="on" v-bind="attrs">
                <v-icon color="grey"> {{ button.icon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ button.title }}</span>
          </v-tooltip>
        </v-list-item-action>
      </div>
      <v-menu v-else offset-y>
        <template v-slot:activator="{ on }" v-if="buttonConfigList.length !== 0">
          <v-btn icon v-on="on">
            <v-icon dense>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="button in buttonConfigList" :key="button.title" @click="onClick(button)">
            <v-list-item-content>
              <v-list-item-title>{{ button.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-card-subtitle class="py-0 pl-0 text-h6 ellipsis text-recommendation">{{ ruleDescription }}</v-card-subtitle>
    <v-card-actions class="d-flex flex-wrap pa-0 pb-4">
      <v-chip v-for="(chip, index) in ruleChips" v-bind:key="index" small class="mt-2 mr-3">
        <div class="chip-text">{{ getChipText(chip) }}</div>
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';
import { ProductRecommendation } from '../models';

@Component
@MapGetters(['masterProductList'])
export default class ProductRecommendationCard extends Vue {
  @Prop({ type: ProductRecommendation, required: true }) recommendation;

  get buttonConfigList() {
    return [{
      title: `${this.$t('edit')}`,
      icon: 'mdi-pencil',
      emitName: 'edit'
    },
    {
      title: `${this.$t('delete')}`,
      icon: 'mdi-trash-can-outline',
      emitName: 'delete'
    }];
  }

  get ruleName() {
    return this.recommendation.getParentName(this.masterProductList) || this.$t('undefinedProduct');
  }

  get ruleDescription() {
    return this.recommendation.text;
  }

  get ruleChips() {
    return this.recommendation.getChildNames(this.masterProductList);
  }

  getTitle(guid) {
    const found = this.masterProductList.find((product) => product.guid === guid);
    return found?.commercialName || found?.name || this.$t('undefinedProduct');
  }

  trimString(input, numCharacters) {
    const string = input.toString();
    return string.substring(0, numCharacters) + (string.length > numCharacters ? '...' : '');
  }

  getChipText(chip) {
    return this.trimString(chip, 35) || this.$t('undefinedProduct');
  }

  onDelete() {
    this.$emit('delete', this.recommendation);
  }

  onEdit() {
    this.$emit('edit', this.recommendation);
  }

  onClick(button) {
    this.$emit(button.emitName);
  }
}

</script>

<style scoped>
.chip-text {
  font-size: 12px;
  color: #545454;
  font-weight: bold;
}

.ellipsis{
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.text-recommendation {
  -webkit-line-clamp: 2;
}
</style>
